import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Table } from "react-bootstrap";
import Select from "react-select";
import { addCreditNote, getCustomerDetails, getCustomerList, getInvoiceDetailsByUUID, getInvoicesList, getPriceDetails, getTermsConditionKeyValue } from "../../../services";
import { toast } from "react-hot-toast";
import { Spinner } from "react-bootstrap";
import Button from "@mui/material/Button";

const CreateCreditNote = () => {
    var curr = new Date();
    curr.setDate(curr.getDate());
    var date1 = curr.toISOString().substring(0, 10);
    const defaultSelectedInvoice = {
        label: "Select Invoice",
        value: "",
    };
    const [invoiceOrCustomer, setInvoiceOrCustomer] = useState("invoice");
    const [invoiceListOptions, setInvoiceListOptions] = useState([]);
    const [invoiceDetails, setInvoiceDetails] = useState(null);
    const [customerDetails, setCustomerDetails] = useState(null);
    const [selectedInvoice, setSelectedInvoice] = useState(defaultSelectedInvoice);
    const [customerListOptions, setCustomerListOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState({
        label: "Select Customer",
        value: "",
    });
    const [termsOptions, setTermsOptions] = useState([]);
    const [priceListItemsDetails, setPriceListItemsDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState(date1);
    const [note, setNote] = useState("");
    const [cNo, setCNo] = useState("");
    const [withItems, setWithItems] = useState("true"); // taking 'true' as string because of react bootstrap radio button
    const [terms, setTerms] = useState({
        value: "",
        label: "",
    });

    useEffect(() => {
        getAllInvoiceOrders();
        customerAllRecords();
        getTerms();
    }, []);

    const getTerms = () => {
        getTermsConditionKeyValue().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setTermsOptions(options);
                setTerms(options[0]);
            } else {
                toast(res.message);
            }
        });
    };

    const customerAllRecords = () => {
        var request = {
            page: 0,
            search: "",
            size: -1,
        };
        getCustomerList(request).then((response) => {
            if (response.errorCode === 0) {
                const arr = [];
                response.responsePacket.data.map((data) =>
                    arr.push({
                        value: data.recordId,
                        label: data.title,
                    })
                );
                setCustomerListOptions(arr);
                {/* TODO - uncomment */}
                // setSelectedCustomer(arr[0]);
            } else {
                toast(response.message);
            }
        });
    };

    const getAllInvoiceOrders = () => {
        let list_data = {
            page: 0,
            size: -1,
            search: "",
        };
        getInvoicesList(list_data).then((response) => {
            if (response.errorCode === 0) {
                const arr = [];
                response.responsePacket.data.map((data) =>
                    arr.push({
                        value: data.recordId,
                        label: data.customerTitle,
                        invoiceNo: data.invoiceNo,
                        salesOrderNo: data.salesOrderNo,
                    })
                );
                arr.unshift(defaultSelectedInvoice);
                setInvoiceListOptions(arr);
            } else {
                toast(response.message);
            }
        });
    };

    useEffect(() => {
        if (selectedInvoice.invoiceNo) {
            getInvoiceDetailsByUUID(selectedInvoice.value).then((res) => {
                if (res.errorCode === 0) {
                    setInvoiceDetails(res.responsePacket);
                } else {
                    toast(res.message);
                }
            });
        }
    }, [selectedInvoice]);

    useEffect(() => {
        if (selectedCustomer.value) {
            getCustomerDetails(selectedCustomer.value).then((res) => {
                if (res.errorCode === 0) {
                    setCustomerDetails(res.responsePacket);
                } else {
                    toast(res.message);
                }
            });
        }
    }, [selectedCustomer]);

    useEffect(() => {
        if (customerDetails && withItems === "true") {
            getPriceDetails(customerDetails.itemPriceListRecordId).then((priceListRes) => {
                if (priceListRes.errorCode === 0) {
                    setPriceListItemsDetails(priceListRes.responsePacket);
                } else {
                    toast.error(priceListRes.message);
                }
            });
        }
    }, [withItems, selectedCustomer, customerDetails]);

    const handleQty = (e, i) => {
        const obj = invoiceDetails.itemsList;
        let qt = Number(e.target.value);
        if (qt > obj[i].quantity) {
            return;
        }
        obj[i].qty = qt;
        setInvoiceDetails({ ...invoiceDetails, itemsList: obj });
    };

    const handleCustomerListQty = (e, i) => {
        const obj = priceListItemsDetails.itemCustomUnitPriceBeanList;
        let qt = Number(e.target.value);
        obj[i].qty = qt;
        setInvoiceDetails({ ...priceListItemsDetails, itemCustomUnitPriceBeanList: obj });
    };

    const submitCreditNote = () => {
        setLoading(true);
        let subTotal = 0;
        let netTax = 0;
        let arr = invoiceDetails.itemsList.filter((a) => a.qty);

        arr?.map((a) => {
            a.quantity = a.qty;
            a.amount = a.rate * a.qty;
            subTotal += a.amount;
            a.taxBean.amount = a.amount * a.taxBean.rate * 0.01;
            netTax += a.taxBean.amount;
        });

        if (arr.length === 0) {
            toast("please select at least 1 item");
            setLoading(false);
            return;
        }

        let creditTotal = subTotal + netTax;

        let data = {
            creditNoteTermsConditionId: terms.value,
            creditNoteTermsConditions: terms.label,

            creditNoteIssueDate: date,
            creditNoteNoAlt: cNo,

            creditsRemaining: creditTotal,
            isRedeemed: true,
            reference: note,

            roundOffId: 1,
            roundOffTitle: "Round off to nearest zero",

            customerId: invoiceDetails.customerId,
            customerTitle: invoiceDetails.customerTitle,
            invoiceDate: invoiceDetails.invoiceDate,
            invoiceId: invoiceDetails.recordId,
            invoiceNo: invoiceDetails.invoiceNo,
            priceListId: invoiceDetails.priceListId,
            priceListTitle: invoiceDetails.priceListTitle,
            salespersonId: invoiceDetails.salespersonId,
            salespersonTitle: invoiceDetails.salespersonTitle,

            subTotalAmount: subTotal,
            totalAmount: creditTotal,
            totalTaxAmount: netTax,
            creditNoteItemsList: arr,
        };

        addCreditNote(data)
            .then((res) => {
                if (res.errorCode === 0) {
                    toast(res.message);
                    setSelectedInvoice(defaultSelectedInvoice);
                    setTerms(termsOptions[0]);
                    setDate(date1);
                    setCNo("");
                    setNote("");
                    setLoading(false);
                } else {
                    setLoading(false);
                    toast(res.message);
                }
            })
            .catch(() => {
                toast.error("server error");
                return;
            });
    };

    return (
        <div className="details-container p-5 mx-auto details-page">
            <h2 className="font-weight-bold font-size-20 text-center">Credit Info</h2>
            <div className="d-flex justify-content-between font-size-16">
                {/* uncomment this to enable without invoice code*/}
                {/* <RadioGroup name='type' row value={invoiceOrCustomer} onChange={(e) => setInvoiceOrCustomer(e.target.value)}>
                    <FormControlLabel defaultChecked value='invoice' control={<Radio size='small' />} label='With Invoice' />
                    <FormControlLabel value='customer' control={<Radio size='small' />} label='Without Invoice' />
                </RadioGroup> */}
            </div>
            <br />
            {invoiceOrCustomer === "invoice" ? (
                <>
                {/* TODO - uncomment */}
                    {/* Customer */}
                    {/* <h4 className="font-weight-bold">Customer</h4>
                    <div className="row my-3">
                        <div className="col-5">
                            <Select options={customerListOptions} value={selectedCustomer} onChange={(e) => setSelectedCustomer(e)} />
                        </div>
                        <div className="col-7">
                            <div className="d-flex align-items-center">
                                <span className="text-grey">Selected Customer: </span>
                                <span className="ml-2 font-size-16 font-weight-600">{selectedCustomer.label}</span>
                            </div>
                            <div className="d-flex align-items-center">
                                <span className="text-grey">Selected Price List: </span>
                                <span className="ml-2 font-size-16 font-weight-600">{customerDetails?.itemPriceListTitle}</span>
                            </div>
                        </div>
                    </div>
                    <hr className="my-4" style={{ background: "#c9c9c9" }} /> */}

                    {/* Invoice */}
                    <h4 className="font-weight-bold">Invoice</h4>
                    <div className="row">
                        <div className="col-5">
                            <Select options={invoiceListOptions} value={selectedInvoice} onChange={(e) => setSelectedInvoice(e)} />
                        </div>
                        <div className="col-7">
                            <div className="d-flex mt-3 justify-content-end align-items-center">
                                {selectedInvoice.value !== "" && (
                                    <>
                                        <span>Invoice No.: </span>
                                        <span className="ml-2 font-size-16">{selectedInvoice.invoiceNo}</span>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    <hr className="my-4" style={{ background: "#c9c9c9" }} />
                </>
            ) : (
                <>
                    <Select options={customerListOptions} value={selectedCustomer} onChange={(e) => setSelectedCustomer(e)} />
                    <div className="d-flex mt-3 align-items-center">
                        <span className="text-grey">Selected Customer: </span>
                        <span className="ml-2 font-size-16 font-weight-600">{selectedCustomer.label}</span>
                    </div>
                    <div className="d-flex mt-3 align-items-center">
                        <span className="text-grey">Selected Price List: </span>
                        <span className="ml-2 font-size-16 font-weight-600">{customerDetails.itemPriceListTitle}</span>
                    </div>
                </>
            )}
            {invoiceOrCustomer === "customer" && (
                <>
                    <hr className="hr-grey" />
                    <div className="d-flex justify-content-between font-size-16">
                        <RadioGroup name="type" row value={withItems} onChange={(e) => setWithItems(e.target.value)}>
                            <FormControlLabel defaultChecked value={true} control={<Radio size="small" />} label="With Items" />
                            <FormControlLabel value={false} control={<Radio size="small" />} label="Without Items" />
                        </RadioGroup>
                    </div>
                </>
            )}
            <Table>
                <tr>
                    <td style={{ width: "100px" }}>Terms</td>
                    <td style={{ width: "100px" }}>
                        <Select options={termsOptions} isDisabled value={terms} onChange={(e) => setTerms(e)} />
                    </td>
                </tr>
                <tr>
                    <td>Date</td>
                    <td>
                        <input autoComplete="off" type="date" value={date} className="form-control" onChange={(e) => setDate(e.target.value)} />
                    </td>
                </tr>
                <tr>
                    <td>CreditNo.</td>
                    <td>
                        <input autoComplete="off" value={cNo} className="form-control" onChange={(e) => setCNo(e.target.value)} />
                    </td>
                </tr>
                <tr>
                    <td>Note</td>
                    <td>
                        <input autoComplete="off" value={note} className="form-control" onChange={(e) => setNote(e.target.value)} />
                    </td>
                </tr>
                {invoiceOrCustomer === "customer" && customerDetails && (
                    // customerDetails.discountType !== "None" &&
                    <>
                        <tr>
                            <td>Discount Value</td>
                            <td>
                                <input autoComplete="off" value={customerDetails.discountValue} className="form-control" disabled style={{ background: "#ffffff" }} />
                            </td>
                        </tr>
                        <tr>
                            <td>Tax Applicable</td>
                            <td>
                                <input autoComplete="off" value={customerDetails.taxApplicable} className="form-control" disabled style={{ background: "#ffffff" }} />
                            </td>
                        </tr>
                    </>
                )}
            </Table>
            {selectedInvoice.value !== "" ? (
                <>
                    <Table className="bootTable w-100">
                        <thead>
                            <tr>
                                <th>Items</th> <th>Invoiced Qty</th> <th>Credit for Qty</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoiceDetails &&
                                invoiceDetails.itemsList &&
                                invoiceDetails.itemsList.length > 0 &&
                                invoiceDetails.itemsList.map((data, i) => (
                                    <tr key={i}>
                                        <td>{data.itemTitle}</td>
                                        <td>{data.quantity}</td>
                                        <td>
                                            <input autoComplete="off" className="form-control" value={data.qty ? data.qty : ""} min={0} type="number" onChange={(e) => handleQty(e, i)} />
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </Table>
                </>
            ) : (
                withItems === "true" && (
                    <>
                        <Table className="bootTable w-100">
                            <thead>
                                <tr>
                                    <th>Items</th> <th>Custom Price / Unit</th> <th>Credit for Qty</th>
                                </tr>
                            </thead>
                            <tbody>
                                {priceListItemsDetails &&
                                    priceListItemsDetails.itemCustomUnitPriceBeanList &&
                                    priceListItemsDetails.itemCustomUnitPriceBeanList.length > 0 &&
                                    priceListItemsDetails.itemCustomUnitPriceBeanList.map((data, i) => (
                                        <tr key={i}>
                                            <td>{data.itemTitle}</td>
                                            <td>{data.customPrice + " / " + data.unitTitle}</td>
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    className="form-control"
                                                    value={data.qty ? data.qty : ""}
                                                    min={0}
                                                    type="number"
                                                    onChange={(e) => handleCustomerListQty(e, i)}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </Table>
                    </>
                )
            )}
            <div className="text-center">
                {loading ? (
                    <Button variant="contained">
                        <Spinner />
                    </Button>
                ) : (
                    <Button variant="contained" onClick={submitCreditNote}>
                        Save
                    </Button>
                )}
            </div>
        </div>
    );
};

export default CreateCreditNote;
